
import { useCookies } from '@vueuse/integrations/useCookies'

const cookie = useCookies()

//获取cookie
export function getCookie(cookieKey) {
    return cookie.get(cookieKey)
}

//设置cookie
export function setCookie(cookieKey, cookieValue) {
    return cookie.set(cookieKey, cookieValue)
}

//清除cookie
export function removeCookie(cookieKey) {
    return cookie.remove(cookieKey)
}

